if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.primaryButton = this.form?.querySelector('[name="add"]');
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.button = this.querySelector('.sticky-add-to-cart__button');
      this.buttonLabel = this.querySelector('[data-sticky-button-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.image = this.querySelector('.sticky-add-to-cart__image');
      this.footer = document.querySelector('.footer');

      if (!this.form || !this.primaryButton || !this.variantInput || !this.button) return;

      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
      this.onScroll = this.requestVisibilityUpdate.bind(this);
      this.onVariantChange = this.updateVariant.bind(this);
      this.onButtonClick = this.submitPrimaryForm.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      this.variantInput.addEventListener('change', this.onVariantChange);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.buttonObserver = new MutationObserver(() => this.syncButtonState());
      this.buttonObserver.observe(this.primaryButton, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled'],
      });

      this.updateVariant();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onButtonClick);
      this.variantInput?.removeEventListener('change', this.onVariantChange);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.buttonObserver?.disconnect();
      cancelAnimationFrame(this.visibilityFrame);
    }

    requestVisibilityUpdate() {
      if (this.visibilityFrame) return;
      this.visibilityFrame = requestAnimationFrame(() => {
        this.visibilityFrame = null;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      const passedProductForm = this.primaryButton.getBoundingClientRect().bottom < 0;
      const nearingFooter = this.footer && this.footer.getBoundingClientRect().top <= window.innerHeight + 96;
      const visible = passedProductForm && !nearingFooter;

      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
    }

    updateVariant() {
      const variant = this.variants.find(({ id }) => String(id) === this.variantInput.value);
      if (!variant) return;

      this.price.textContent = variant.price;
      if (this.image && variant.image) this.image.src = variant.image;
      const testEnabled = Boolean(this.form.closest('product-form')?.dataset.productTestId);
      this.button.disabled = !variant.available && !testEnabled;
      this.buttonLabel.textContent = (variant.available || testEnabled) ? window.variantStrings.addToCart : window.variantStrings.soldOut;
    }

    syncButtonState() {
      const loading = this.primaryButton.classList.contains('loading');
      const disabled = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';

      this.button.classList.toggle('is-loading', loading);
      this.button.disabled = disabled;
    }

    submitPrimaryForm() {
      if (this.button.disabled) return;
      this.button.classList.add('is-loading');
      this.form.dataset.productTestSource = 'sticky';
      this.form.requestSubmit(this.primaryButton);
      delete this.form.dataset.productTestSource;
      if (this.form.closest('product-form')?.dataset.productTestId) this.button.classList.remove('is-loading');
    }
  });
}
